import { Box } from "@mui/material";
import React from "react";

interface Props {
  title: string;
  icon?: React.ReactNode;
}

export default function FilterItem({ title, icon }: Props) {
  return (
    <Box
      sx={{
        whiteSpace: "nowrap",
        border: "1px solid #78909C",
        padding: "6px",
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        color: "#78909C",
      }}
    >
      {icon}
      {title}
    </Box>
  );
}
